<template>
        <div>
            <div class="row no-wrap order_line justify-left">
                <div class="col-sm-3 col-md-2 col-lg-2 col-xl-2 col-xs-3 self-center justify-left buttonContainer row no-wrap" >
             <!-- Блок кнопок, если запись не заблокирована -->
                    <div v-if="!isLock" class='row no-wrap ellipsis'>
                        <q-checkbox v-model="comp_checked" class="icon_button" color='positive' @input="toggleCheckBox"/>

                        <div class="icon_button self-center gt-md q-ml-xs" @click="deleteOrder" v-if='order.stage < 3'>
                            <q-icon name="delete_outline" color="grey-8" size="20px" />
                        </div>

                        <div class="icon_button self-center q-ml-xs" @click="showOrderDetails" >
                            <q-icon name="list" color="light-blue-10" size="20px" />
                        </div>

                        <div class="icon_button self-center q-ml-xs" @click="editOrder" v-if='(order.stage < 3)||((order.stage==4)&&($store.getters.isAllowPermission("*")))'>
                            <q-icon name="edit" color="red-10" size="20px"  class='gt-xs'/>
                        </div>

                        <div style='width:35px;' class='gt-xs'>
                            <div v-if='isPay'>                                
                                <q-btn icon='fas fa-ruble-sign' dense round outline flat size='sm' color='red' v-if='order.pay_status==0' @click = 'editBill'>
                                    <q-tooltip :delay="500">
                                        {{payInfo}}
                                    </q-tooltip>                                   
                                </q-btn>
                                <q-btn icon='fas fa-ruble-sign' dense round outline flat size='sm' color='primary' v-if='order.pay_status==1' @click = 'editBill'>
                                    <q-tooltip :delay="500">
                                        {{payInfo}}
                                    </q-tooltip>                                   
                                </q-btn>
                                <q-btn icon='fas fa-ruble-sign' dense round outline flat size='sm' color='positive' v-if='order.pay_status==2' @click = 'editBill'>
                                    <q-tooltip :delay="500">
                                        {{payInfo}}
                                    </q-tooltip>
                                </q-btn>
                            </div>
                        </div>
                         <div class="self-center order_num ellipsis  q-px-sm">{{ order.id }}</div>
                    </div>

              <!-- Блок, если запись заблокирована  -->

                    <div v-if='isLock' class='row no-wrap justify-start'>
                        <q-icon name="lock" color="red-10" class='q-ml-md' v-on:dblclick.native="forceUnlock" style='cursor:pointer'>
                            <q-tooltip :delay="500">
                                        {{lockInfo}}
                            </q-tooltip> 
                        </q-icon>
                        <q-icon name="fas fa-arrow-right" color="grey-6" class='q-ml-md q-mr-md' />
                        <div class="self-center order_num ellipsis" v-bind:class="{'q-caption': $q.screen.lt.md}" >{{ order.id }}</div>
                    </div>
        
                </div>
                <div class="col-sm-3 col-md-2 col-lg-2 col-xl-2 col-xs-4 row no-wrap self-center contragent ellipsis col-xs-3"> 
                    <div class='text-weight-bold' v-bind:class="{'q-caption': $q.screen.lt.md}">{{ getContragentName }}</div>
                    <q-icon name="fas fa-hand-point-right" color="grey-5" size="15px" class='q-ml-md q-mr-sm' v-if='getExecutorName >""' />
                    <div class='text-grey-8 text-weight-medium'>{{ getExecutorName }}</div>
                </div>

                <div class="col-sm-2 col-md-2 col-lg-1 col-xl-1 self-center contragent ellipsis q-px-sm col-xs-3" v-bind:class="{'q-caption': $q.screen.lt.md}"> {{ NiceDate }}</div>

                <div class="col-2 self-center contragent ellipsis q-px-sm gt-xs"> 
                    <q-icon name="fas fa-user" size="15px" class='text-blue-5 q-ml-sm q-mr-sm'/>
                    {{ ManagerName }}
                </div>


                <div class="gt-sm self-center col-2 ellipsis q-px-sm" 
                    @click="edit">
                    <span v-if="noComment" class='text-grey-5 text-italic text-weight-thin q-caption ellipsis'>комментарии к заказу</span>
                    <span v-if="!editMode" class='text-italic'> {{ comment }}</span>
                    <span v-if="editMode">
                        <input type=text
                            v-model="order.comment"
                            v-on:blur="doneEdit"
                            @keyup.enter="lostFocus"
                            @keyup.esc="cancelEdit"
                            class="comment-input"
                            v-focus
                        /> 
                    </span>
                </div>
                <div class="col-2 col-lg-3 row no-wrap justify-end">
                    
                    <!-- Блок кнопок управления в блоке "Проверка" -->
                    <div v-if='order.stage==2' class=' row no-wrap justify-end'>
                        
                        <div v-if='!isLock&&!isCloudLoading' class='row no-wrap justify-end'>
                            <div class="icon_button control_button" v-tooltip="''" @click="setToWork">
                                    <q-icon name="play_circle_filled" size='15pt' />
                            </div>

                            <!-- <div class="icon_button control_button"> -->
                                <!-- здесь нужно будет добавить функционал просмотра загруженных в облако файлов -->
                                
                                <div v-on:click ='showCloudUploadDialog'>
                                    <q-icon class='control_button icon_button' name="fas fa-cloud" color='blue-4' size='15pt'  v-if='order.fileCloud==1'/>
                                    <q-icon 
                                        class='control_button icon_button' 
                                        name="fas fa-cloud-upload-alt"  
                                        size='15pt'   
                                        v-if='(order.fileCloud==0)&&(order.stage < 3)' 
                                        
                                    />
                                </div>
                        </div>
                        
                        <div v-if='!isLock'>
                            <div v-if='isCloudLoading'>
                                    <q-spinner-hourglass color="primary" size="15pt" />
                            </div>
                        </div>

                    </div>
                    
                    <!-- Блок кнопок управления в блоке "В работе" -->
                    <div v-if='order.stage==3' class='justify-end row no-wrap'>
                        <div class="icon_button control_button" v-tooltip="''" @click="stopWork" >
                                <q-icon name="far fa-pause-circle" size='15pt' color='primary' />
                        </div>
                        <div class="icon_button self-center control_button" v-tooltip="''"  @click="executorReady">
                            <q-icon name="fas fa-arrow-alt-circle-down" size='15pt' color='green' v-if='order.executor > 0' />
                        </div>
                    </div>

                    <div v-if='order.stage==4' class=''>
                        <q-icon name="fas fa-check-circle" color='positive' size='15pt'/>
                    </div> 

                </div>

            </div> 
            <details-block 
                :orderId = order.id
                :key = order.id
                v-bind:isVisible = 'detailVisible'
            />
        </div>
</template>


<script>

/* eslint-disable */

    const month = [
        'янв', "фев", "мар", "апр", "мая", "июн", "июл", "авг", "сен", "окт", "ноя", "дек"
    ];

    export default {

        props:{
            order : {
                type: Object,
                requered: true,
            },
            orderComment : '',
        },

        data () {
            return {
                editMode: false,   
                checked : false,      
                needSave : false,   
                caсheComment : '',
                toolTipDelay : 1000,
                detailVisible : false,
                fileLoading : false,
                goTest : false,
                isChanged : false,
            }
        },
        components : {
            detailsBlock:() => import("./orderLineDetails.vue")
        },

        watch : {
            order : function(val) {
                // console.log('я его вычислил')
            }
        },
        
        directives: {
            focus: {
                // определение директивы
                inserted: function (el) {
                    el.focus()
                }
            },

        },

       methods :{
           forceUnlock() { //принудительная разблокировка заказа
               //сначала спрашиваем
                this.$q.dialog({
                        title: 'Принудительная разблокировка',
                        message: 'Подтвердите принудительную разблокировку заказа '+ this.order.id +'. Надеемся это Вам действительно необходимо.',
                        color: 'primary',
                        ok: 'Разблокировать', 
                        cancel: 'Отмена',
                })
                .then(()=> {

                    this.$store.dispatch('unlockOrder', this.order.id)
                    .then(() => {
                        this.$admns.showNotify('Заказ разблокирован.','success','Сообщение системы')
                    })
                    .catch((error) => {
                        this.$admns.showNotify('Ошибка при разблокировке','error','Сообщение системы')
                    });

                })
                .catch();
           },
           executorReady() { // готовность заказа от подрядчика

                this.$q.dialog({
                    title: 'Внимание!',
                    color: 'primary',
                    message: 'Отметить готовность заказа №'+this.order.id +"?",
                    ok: 'Заказ готов',
                    cancel: 'Отмена'
                })
                .then( ()=> {

                    this.$store.dispatch('executorReady', this.order.id)
                    .then(()=>{
                        this.$admns.showNotify("Заказа №"+this.order.id+ " готов.","success","Сообщение системы")
                    })
                    .catch((error => {

                    }));

                })
                .catch((error)=>{
                    
                    console.log(error);
                });


           },

           stopWork() { // Пробуем снять с работы
           
                this.$q.dialog({
                    title: 'Внимание!',
                    color: 'primary',
                    message: 'Снять с работы заказ №'+this.order.id +"?",
                    ok: 'Снять с работы',
                    cancel: 'Отмена'
                })
                .then( ()=> {

                    this.$store.dispatch('stopWork', this.order.id)
                    .then(()=>{
                        this.$admns.showNotify("Выполнение заказа №"+this.order.id+ " остановлено.","success","Сообщение системы")
                    })
                    .catch();

                })
                .catch((error)=>{
                    
                    console.log(error);
                });
           },
           
            editBill() {
               eventBus.$emit('openBillDialog', this.order);
            },
           
            toggleCheckBox(){
               this.$store.commit('selectOrder',{id:this.order.id, status:this.checked});
            },


           setToWork() { // Пробуем запустить в работу


                // получаем ордер по его ид чтобы понять кто исполнитель

                let _order = this.$store.getters.getOrderById(this.order.id); //загружаем на всякий случай из стора
                let _executor = this.$store.getters.getExecuterById(_order.executor);
                var add_message = '';
                if ((_executor != undefined)&&(_executor > 0)) { // значит вариант когда отправляем заказы на сторону на исполнение
                    let _opt = JSON.parse(_executor.options); // парсим опции
                    console.log(_opt);
                    if (_opt['email'] != '') {
                        add_message = ' Датели заказа будут оправлены на почту '+_opt.email+ '. Исполнитель: '+_executor.name;
                    } else
                    {
                        add_message = ' Заказу присвоен исполнитель "'+_executor.name+ '", но адрес почты не определен. Детали заказа не будут отправлены';
                    }
                }

                // this.$q.dialog({
                //     title: 'Внимание!',
                //     color: 'primary',
                //     message: 'Запуск в работу заказ №' + this.order.id+'.' + add_message,
                //     ok: 'Запустить в работу',
                //     cancel: 'Отмена'
                // })
                // .then( ()=> {

                    eventBus.$emit('showCheckDialog', this.order.id);

                    // this.$store.dispatch('setToWork', this.order.id)
                    // .then(()=>{
                    //     this.$admns.showNotify("Заказ №"+this.order.id+ " запущен в работу.","success","Сообщение системы")
                    // })
                    // .catch();

                // })
                // .catch((error)=>{
                //     console.log(error);
                // });


           },
           
           showOrderDetails() {
               this.detailVisible = !this.detailVisible;
           },

           editOrder() {
               //тут нужно заблокировать ордер для редактирования
               this.$store.dispatch('lockOrder', this.order.id)
               .then(()=>{
                    this.detailVisible = false; // скрываем детализацию (т.е. она не обновляется)
                    eventBus.$emit('mainEdit', this.order); 
               })
               .catch(error => {
                   this.$admns.showNotify('Не удалось заблокировать запись для изменения','error','Сообщение системы');
                   if (error.response.status == 401) {
                       this.$router.push('logout')
                   }
                   console.log(error);
               })
                
           },

           showCloudUploadDialog() {
               console.log('Показать бы диалог')
               eventBus.$emit('openCloudUploadDialog', this.order.id);
           },

           deleteOrder() {
               eventBus.$emit('deleteOrder', this.order);
           },

           edit() {
               if (!this.editMode) {
                   this.needSave = true;
                   this.cacheComment = this.order.comment;
                   this.editMode = true;
               }
           },
           
           cancelEdit() {

               this.needSave = false;
               this.order.comment = this.cacheComment;
               this.editMode = false;
              
           },

           lostFocus() {
                this.needSave = true;
                this.editMode = false;
                this.doneEdit();
           },

           doneEdit() {
                this.editMode = false;
                if (!this.needSave) return;

                this.$store.dispatch('updateOrder', {
                    'id' : this.order.id,
                    'comment' : this.order.comment,
                });
           },
 
       },

       created() {
       },

        computed: { 
            
            lockInfo() {
                let user = this.$store.getters.getUserById(this.order.lock_by);
                let blockName = user != null ? 'Заблокировано: '+ user.name + " " + user.surname : 'Заблокировано: '+ 'Неизвестно'
                let result = '';
                let d = new Date(this.order.lock_at);
                let offset = d.getTimezoneOffset()/60;
                d.setHours(d.getHours()-offset);
                result += blockName +' -- ' + d.toLocaleTimeString();
                return result;
            },

            payInfo() {
                if (this.order.pay_info == null) return '';
                let q = JSON.parse(this.order.pay_info);
                let result = '';
                for (var i in q) {
                    result += i + ': '+q[i]+'  ';
                }
                return result;
            },
            noComment() {
                return (this.order.comment == undefined) && (!this.editMode);
            },

            isCloudLoading() {
                if (this.$store.getters.isOrderUpload(this.order.id)==undefined) return false;
                return true;
            },


            comp_checked: {
                get: function () {
                    let selectedOrders = this.$store.getters.getSelectedOrders;
                    return selectedOrders.indexOf(this.order.id) != -1;
                },
                set: function (newValue) {
                     this.checked = newValue;
                }
            },
            
            isPay() {
                return this.order.bill_out != null;
            },


            isLock() {
                return this.order.lock_at != null;
            },

            getExecutorName() {
                if (this.order.executor == 0) return '';
                var q = this.$store.getters.getExecuterById(this.order.executor);
                if (q==undefined) return '';
                return q.name;

            },

            getContragentName() {
                var q = this.$store.getters.getContragentById(this.order.contragent);
                if (q==undefined) return '';
                return this.$store.getters.getContragentById(this.order.contragent).name;
              
            },

            NiceDate() {
                var st = this.order.created_at;
                let d = new Date(this.order.created_at);
                var options = { year: '2-digit', month: 'short', day: 'numeric' };
                return d.toLocaleDateString('ru', options);
            },

            ManagerName() {
                var q = this.$store.getters.getUserById(this.order.manager);
                if (q==undefined) return '';
                return q.name+' '+q.surname;
            },

            comment() {
               return this.order.comment; 
            }

        }
    }

</script>

<style  lang="scss" scoped>
    @keyframes myBack {
        from { background-color: rgb(137, 250, 137)}
        to {background-color :rgb(231, 231, 231)}
    }
    
    .updatedLine {
        animation: myBack  2s ease-in-out;
    }

    .order_line {
        background: rgb(231, 231, 231);
        margin: 0px;
        padding : 6px;
        border : 1px solid;
        border-top-color :rgb(211, 211, 211); 
        border-left-color :rgb(211, 211, 211); 
        border-bottom-color: darkgray;
        border-right-color: darkgray;

        // font-family: Arial, sans-serif;
        font-size: 15px;
        // display: flex;
        height: 35px;
        width : 100%;
        // min-width: 300px;

        &:hover {
            background: lightgreen;
        }
        .icon_button {
            width:25px;
            cursor: pointer;
            float : left;
        }        
        .control_button {
            // width : 32px;
            // text-align: center;
            color: #B8B8B8;
            &:hover {
                color : green;
            }
        }

        .order_num {
            font-weight: bold;
            min-width: 60px;
        }
        .contragent{
            font-weight:normal;
        }
        .date_field {
            font-size: 15px;
        }
        .managerName_field {
            font-size: 15px;

            min-width: 180px;
        }
        .right_container {
            justify-content : flex-end;
            width : 100%;
            display : flex;
            overflow: hidden;
        }
        .comment_field {
            font-size: 15px;
            min-width: 250px;
            overflow: hidden;
        }
        .buttonContainer {
            min-width : 60px;
        }
        .takeIco {
            width:18px;
        }

     
        .comment-input{
            width:100%;
            background: white;
            box-shadow: 5 5 5px rgba(0, 81, 255, 0.5); /* Параметры тени */
        }
    }
    .test {
       animation: shadow 1s ease-in-out 0.5s alternate, move 5s linear 2s;
    }



</style>

